import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-512b976e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "widget-item",
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  style: {
    "margin-left": "16px"
  }
};
const _hoisted_4 = {
  key: 4,
  class: "buttons__list"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_6 = ["innerHTML"];
import ModelTags from '@/components/ModelTags/index.vue';
import AllCheck from '@/components/AllCheck/index.vue';
import DoubleInput from '../DoubleInput/index.vue';
import SortDoubleInput from '../SortDoubleInput/index.vue';
import PopModelTags from '@/components/PopModelTags/index.vue';
import SingleSelect from '@/components/SingleSelect/index.vue';
import MultipleSelect from '@/components/MultipleSelect/index.vue';
import MultipleSelectObj from '@/components/MultipleSelectObj/index.vue';
import InputGroup from '@/components/InputGroup/index.vue';
import { safeHtml } from '@/utils/sanitize';
import { useI18n } from 'vue-i18n';
import { getTextWidth } from '@/utils';
import { nextTick } from 'vue';
const __default__ = {
  name: "WidgetItem",
  inheritAttrs: false
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    widgetConfig: {
      type: Object,
      required: true
    },
    widgetData: {
      type: Object,
      required: true
    },
    scopeData: {
      type: Object,
      default: {}
    }
  },
  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const addEvent = (item, value, type) => {
      tipDisabled.value = false;
      if (!item.disabled) {
        item[type] && item[type](value, props.widgetData);
        const {
          func
        } = item;
        func && func(value, props.widgetData);
      }
    };
    // 下拉多选模式下移除tag时触发
    const removeSelectTag = (value, item) => {
      if (!item.disabled) {
        const {
          removeTag
        } = item;
        removeTag && removeTag(value);
      }
    };
    // 日期选中时间回调
    const calendarChange = (date, item) => {
      const {
        calendarChange
      } = item;
      calendarChange && calendarChange(date);
    };
    // 下拉选项原生点击事件
    const optionItemNativeClick = (value, item) => {
      if (!item.disabled) {
        const {
          optionItemNativeClick
        } = item;
        optionItemNativeClick && optionItemNativeClick(value, item, props.widgetData);
      }
    };
    const initData = () => {
      const {
        formatter,
        prop
      } = props.widgetConfig;
      let value = props.widgetData[prop];
      const result = formatter ? formatter(value, props.widgetData, props.widgetConfig) : value;
      // 该返回值用于 v-html 渲染，统一做 XSS 净化
      return safeHtml(result);
    };
    // 获取label
    const getLabel = (item, config) => {
      const {
        labelKey,
        translation
      } = config;
      const label = item[labelKey ?? 'label'];
      return translation ? t(label) : label;
    };
    const getValue = (item, config) => {
      const {
        valueKey,
        completeValue
      } = config;
      // console.log(valueKey)
      return completeValue ? item : item[valueKey ?? 'value'];
    };
    // 控制按钮
    const controlHide = (scope, btn) => {
      const {
        controller
      } = btn;
      return controller ? controller(scope, btn) : true;
    };
    const controlDisabled = (row, btn) => {
      const {
        controlDisabled
      } = btn;
      return controlDisabled ? controlDisabled(row) : false;
    };
    const controlStyle = (row, btn) => {
      const {
        controlStyle
      } = btn;
      return controlStyle ? controlStyle(row) : '';
    };
    const handleAction = (btn, data) => {
      const {
        func
      } = btn;
      func && func(data);
    };
    // 双击编辑
    const valueChange = (value, done) => {
      const {
        valueChange
      } = props.widgetConfig;
      valueChange && valueChange(value, done);
    };
    // 双击编辑
    const handleValueChange = (newValue, oldValue, done, scopeData) => {
      const {
        onValueChange
      } = props.widgetConfig;
      onValueChange ? onValueChange(newValue, oldValue, done, scopeData) : done();
    };
    const clearEvent = (item, value) => {
      if (!item.disabled) {
        const {
          cfunc
        } = item;
        cfunc && cfunc(value, 0);
      }
    };
    const onPopoverShow = (item, value) => {
      if (!item.disabled) {
        const {
          onPopoverShow
        } = item;
        onPopoverShow && onPopoverShow();
      }
    };
    const visibleChange = (visible, item, value) => {
      if (!item.disabled) {
        const {
          visibleChange
        } = item;
        visibleChange && visibleChange(visible, item, value);
      }
    };
    //  内容超出时显示提示
    const tipDisabled = ref(false);
    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText);
      tipDisabled.value = target.offsetWidth > width;
    };
    const showInputTextTip = e => {
      nextTick(() => {
        const target = e.target;
        // console.log(target.tagName);
        if (target.tagName == 'INPUT') {
          const width = getTextWidth(target.value, {
            fontSize: '14px'
          });
          tipDisabled.value = target.offsetWidth < width;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_tree_select = _resolveComponent("el-tree-select");
      const _component_MPopper = _resolveComponent("MPopper");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.widgetConfig?.widgetType === 'input' ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
        key: 0,
        style: {
          "width": "100%"
        },
        onChange: _cache[0] || (_cache[0] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'change')),
        onInput: _cache[1] || (_cache[1] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'input')),
        onClear: _cache[2] || (_cache[2] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'clear')),
        onBlur: _cache[3] || (_cache[3] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'blur')),
        onFocus: _cache[4] || (_cache[4] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'focus')),
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => __props.widgetData[__props.widgetConfig.prop] = $event)
      }, __props.widgetConfig, {
        placeholder: __props.widgetConfig.placeholder ? _ctx.$t(`${__props.widgetConfig.placeholder}`) : ''
      }), _createSlots({
        suffix: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.suffix || ''), 1)]),
        _: 2
      }, [__props.widgetConfig.prepend ? {
        name: "prepend",
        fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.prepend), 1)]),
        key: "0"
      } : undefined, __props.widgetConfig.append ? {
        name: "append",
        fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.append), 1)]),
        key: "1"
      } : undefined]), 1040, ["modelValue", "placeholder"])) : __props.widgetConfig?.widgetType === 'date' ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
        key: 1,
        onFocus: _cache[6] || (_cache[6] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'focus')),
        onCalendarChange: _cache[7] || (_cache[7] = date => calendarChange(date, __props.widgetConfig))
      }, __props.widgetConfig, {
        onChange: _cache[8] || (_cache[8] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'change')),
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        clearable: __props.widgetConfig.clearable ?? true,
        style: {
          "width": "100%"
        },
        "value-format": __props.widgetConfig.valueFormat ? __props.widgetConfig.valueFormat : 'YYYY-MM-DD hh:mm:ss',
        placeholder: __props.widgetConfig.placeholder ? _ctx.$t(`${__props.widgetConfig.placeholder}`) : ''
      }), null, 16, ["modelValue", "clearable", "value-format", "placeholder"])) : __props.widgetConfig.widgetType === 'Select' ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
        key: 2,
        style: {
          "width": "100%"
        },
        onChange: _cache[10] || (_cache[10] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'change')),
        onVisibleChange: _cache[11] || (_cache[11] = visible => visibleChange(visible, __props.widgetConfig, __props.widgetData[__props.widgetConfig.prop])),
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        "fit-input-width": true,
        "value-key": __props.widgetConfig.valueKey || 'value',
        filterable: __props.widgetConfig.filterable ?? true,
        "reserve-keyword": __props.widgetConfig.reserveKeyword ?? false
      }, __props.widgetConfig, {
        "popper-class": "m-select-popper",
        "no-data-text": _ctx.$t('暂无数据'),
        placeholder: __props.widgetConfig.placeholder ? _ctx.$t(`${__props.widgetConfig.placeholder}`) : '',
        disabled: __props.widgetConfig.disabled,
        onRemoveTag: _cache[13] || (_cache[13] = val => removeSelectTag(val, __props.widgetConfig))
      }), {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.widgetConfig.list || [], (selectItem, idx) => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: getLabel(selectItem, __props.widgetConfig),
            value: getValue(selectItem, __props.widgetConfig),
            disabled: selectItem.disabled,
            onClick: $event => optionItemNativeClick(getValue(selectItem, __props.widgetConfig), __props.widgetConfig)
          }, {
            default: _withCtx(() => [__props.widgetConfig.slotType === 'img' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createElementVNode("img", {
              style: {
                "float": "left",
                "width": "57px",
                "height": "32px"
              },
              src: selectItem.imgUrl,
              alt: ""
            }, null, 8, _hoisted_2), _createElementVNode("span", _hoisted_3, _toDisplayString(selectItem.label), 1)], 64)) : _createCommentVNode("", true), _createVNode(_component_el_tooltip, {
              disabled: _unref(tipDisabled),
              effect: "light",
              "popper-class": "self-popper",
              content: getLabel(selectItem, __props.widgetConfig),
              placement: "top"
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                onMouseover: showTextTip,
                class: "tooltip-item"
              }, _toDisplayString(getLabel(selectItem, __props.widgetConfig)), 33)]),
              _: 2
            }, 1032, ["disabled", "content"])]),
            _: 2
          }, 1032, ["label", "value", "disabled", "onClick"]);
        }), 256))]),
        _: 1
      }, 16, ["modelValue", "value-key", "filterable", "reserve-keyword", "no-data-text", "placeholder", "disabled"])) : __props.widgetConfig.widgetType === 'allCheck' ? (_openBlock(), _createBlock(AllCheck, _mergeProps({
        key: 3,
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        "label-key": __props.widgetConfig.labelKey,
        "value-key": __props.widgetConfig.valueKey,
        options: __props.widgetConfig.list,
        disabled: __props.widgetConfig.disabled,
        showAllCheck: __props.widgetConfig.showAllCheck
      }, __props.widgetConfig), null, 16, ["modelValue", "label-key", "value-key", "options", "disabled", "showAllCheck"])) : __props.widgetConfig.widgetType === 'buttons' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.widgetConfig.buttonsList, (btn, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [controlHide(__props.widgetData, btn) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, _mergeProps({
          key: 0
        }, btn, {
          style: controlStyle(__props.widgetData, btn),
          disabled: controlDisabled(__props.widgetData, btn),
          type: btn.type || 'primary',
          link: "",
          onClick: $event => handleAction(btn, __props.widgetData)
        }), {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(btn.label)), 1)]),
          _: 2
        }, 1040, ["style", "disabled", "type", "onClick"])), [[_directive_permission, btn.permissionKey]]) : _createCommentVNode("", true)], 64);
      }), 256))])) : __props.widgetConfig.widgetType === 'switch' ? (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
        key: 5,
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        "active-color": "#13ce66",
        "inactive-color": "#ff4949"
      }, __props.widgetConfig, {
        onChange: _cache[16] || (_cache[16] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'change'))
      }), null, 16, ["modelValue"])) : __props.widgetConfig.widgetType == 'textarea' ? (_openBlock(), _createBlock(_component_el_input, {
        key: 6,
        autosize: {
          minRows: __props.widgetConfig.minRows,
          maxRows: __props.widgetConfig.maxRows
        },
        style: {
          "width": "100%"
        },
        placeholder: __props.widgetConfig.placeholder ? _ctx.$t(`${__props.widgetConfig.placeholder}`) : '',
        maxlength: __props.widgetConfig.maxlength,
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        "show-word-limit": "",
        clearable: __props.widgetConfig.clear || false,
        size: __props.widgetConfig.size,
        type: "textarea",
        disabled: __props.widgetConfig.disabled
      }, null, 8, ["autosize", "placeholder", "maxlength", "modelValue", "clearable", "size", "disabled"])) : __props.widgetConfig.widgetType === 'selectModel' ? (_openBlock(), _createBlock(ModelTags, {
        key: 7,
        data: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:data": _cache[18] || (_cache[18] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        "apk-list": __props.widgetConfig.apkList,
        searchFormData: __props.widgetConfig.searchFormData
      }, null, 8, ["data", "apk-list", "searchFormData"])) : __props.widgetConfig.widgetType === 'doubleInput' ? (_openBlock(), _createBlock(DoubleInput, {
        key: 8,
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        onValueChange: valueChange
      }, null, 8, ["modelValue"])) : __props.widgetConfig.widgetType === 'sortDoubleInput' ? (_openBlock(), _createBlock(SortDoubleInput, _mergeProps({
        key: 9
      }, __props.widgetConfig, {
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        onOnValueChange: _cache[21] || (_cache[21] = (newValue, oldValue, done) => handleValueChange(newValue, oldValue, done, __props.widgetData))
      }), null, 16, ["modelValue"])) : __props.widgetConfig.widgetType === 'popSelectModel' ? (_openBlock(), _createBlock(PopModelTags, {
        key: 10,
        widgetConfig: __props.widgetConfig,
        data: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:data": _cache[22] || (_cache[22] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        "data-list": __props.widgetConfig.dataList
      }, null, 8, ["widgetConfig", "data", "data-list"])) : __props.widgetConfig.widgetType == 'singleSelect' ? (_openBlock(), _createBlock(SingleSelect, {
        key: 11,
        class: "m-multiple",
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        onChange: _cache[24] || (_cache[24] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'input')),
        onClear: _cache[25] || (_cache[25] = $event => clearEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop])),
        optionList: __props.widgetConfig.list,
        nameField: __props.widgetConfig.nameField ? __props.widgetConfig.nameField : 'name',
        valueField: __props.widgetConfig.valueField ? __props.widgetConfig.valueField : 'id',
        placeholder: __props.widgetConfig.placeholder || '',
        disabled: __props.widgetConfig.disabled || false,
        showSearch: "",
        showAllOption: __props.widgetConfig.showAll || false
      }, null, 8, ["modelValue", "optionList", "nameField", "valueField", "placeholder", "disabled", "showAllOption"])) : __props.widgetConfig.widgetType == 'multipleSelect' ? (_openBlock(), _createBlock(MultipleSelect, {
        key: 12,
        class: "m-multiple",
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        widget: __props.widgetConfig,
        optionList: __props.widgetConfig.list,
        nameField: __props.widgetConfig.nameField ? __props.widgetConfig.nameField : 'name',
        valueField: __props.widgetConfig.valueField ? __props.widgetConfig.valueField : 'id',
        disabled: __props.widgetConfig.disabled || false,
        showSearch: "",
        showAllOption: __props.widgetConfig.showAll || false,
        onOnPopoverShow: _cache[27] || (_cache[27] = $event => onPopoverShow(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop]))
      }, null, 8, ["modelValue", "widget", "optionList", "nameField", "valueField", "disabled", "showAllOption"])) : __props.widgetConfig.widgetType == 'multipleSelectObj' ? (_openBlock(), _createBlock(MultipleSelectObj, {
        key: 13,
        class: "m-multiple",
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        widget: __props.widgetConfig,
        optionList: __props.widgetConfig.list,
        nameField: __props.widgetConfig.nameField ? __props.widgetConfig.nameField : 'name',
        valueField: __props.widgetConfig.valueField ? __props.widgetConfig.valueField : 'id',
        disabled: __props.widgetConfig.disabled || false,
        showSearch: "",
        showAllOption: __props.widgetConfig.showAll || false,
        searchData: __props.widgetData,
        programType: __props.widgetConfig.programType
      }, null, 8, ["modelValue", "widget", "optionList", "nameField", "valueField", "disabled", "showAllOption", "searchData", "programType"])) : __props.widgetConfig.widgetType == 'radioGroup' ? (_openBlock(), _createBlock(_component_el_radio_group, {
        key: 14,
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => __props.widgetData[__props.widgetConfig.prop] = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.widgetConfig.list, item => {
          return _openBlock(), _createBlock(_component_el_radio, {
            label: item.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])) : __props.widgetConfig.widgetType == 'inputGroup' ? (_openBlock(), _createBlock(InputGroup, {
        key: 15,
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => __props.widgetData[__props.widgetConfig.prop] = $event)
      }, null, 8, ["modelValue"])) : __props.widgetConfig.widgetType == 'dateTime' ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
        key: 16
      }, __props.widgetConfig, {
        onChange: _cache[31] || (_cache[31] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'change')),
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        clearable: true,
        style: {
          "width": "100%"
        },
        "value-format": __props.widgetConfig.valueFormat ? __props.widgetConfig.valueFormat : 'YYYY-MM-DD HH:mm:ss',
        type: "datetime",
        placeholder: __props.widgetConfig.placeholder ? _ctx.$t(`${__props.widgetConfig.placeholder}`) : ''
      }), null, 16, ["modelValue", "value-format", "placeholder"])) : __props.widgetConfig.widgetType == 'treeSelect' ? (_openBlock(), _createBlock(_component_el_tree_select, _mergeProps({
        key: 17
      }, __props.widgetConfig, {
        modelValue: __props.widgetData[__props.widgetConfig.prop],
        "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => __props.widgetData[__props.widgetConfig.prop] = $event),
        style: {
          "width": "100%"
        },
        data: __props.widgetConfig.list,
        onChange: _cache[34] || (_cache[34] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'change')),
        "check-strictly": "",
        clearable: __props.widgetConfig.clearable,
        disabled: __props.widgetConfig.disabled || false
      }), null, 16, ["modelValue", "data", "clearable", "disabled"])) : __props.widgetConfig?.widgetType === 'inputWithTooltip' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 18
      }, [__props.widgetConfig.tooltip ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        class: "item",
        effect: "light",
        content: __props.widgetConfig.placeholder ? _ctx.$t(`${__props.widgetConfig.placeholder}`) : '',
        placement: "bottom",
        "popper-class": "tps",
        "trigger-keys": []
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, _mergeProps({
          style: {
            "width": "100%"
          },
          onChange: _cache[35] || (_cache[35] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'change')),
          onInput: _cache[36] || (_cache[36] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'input')),
          onClear: _cache[37] || (_cache[37] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'clear')),
          onBlur: _cache[38] || (_cache[38] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'blur')),
          onFocus: _cache[39] || (_cache[39] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'focus')),
          modelValue: __props.widgetData[__props.widgetConfig.prop],
          "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => __props.widgetData[__props.widgetConfig.prop] = $event)
        }, __props.widgetConfig, {
          placeholder: __props.widgetConfig.placeholder ? _ctx.$t(`${__props.widgetConfig.placeholder}`) : ''
        }), _createSlots({
          suffix: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.suffix || ''), 1)]),
          _: 2
        }, [__props.widgetConfig.prepend ? {
          name: "prepend",
          fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.prepend), 1)]),
          key: "0"
        } : undefined, __props.widgetConfig.append ? {
          name: "append",
          fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.append), 1)]),
          key: "1"
        } : undefined]), 1040, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["content"])) : _createCommentVNode("", true)], 64)) : __props.widgetConfig?.widgetType === 'tooltipInput' ? (_openBlock(), _createBlock(_component_MPopper, _mergeProps({
        key: 19,
        disabled: _unref(tipDisabled),
        placement: __props.widgetConfig.placement ?? 'top',
        trigger: __props.widgetConfig.trigger ?? 'hover'
      }, __props.widgetConfig, {
        teleported: true
      }), {
        reference: _withCtx(() => [_createVNode(_component_el_input, _mergeProps({
          onMouseover: showInputTextTip,
          style: {
            "width": "100%"
          },
          onChange: _cache[41] || (_cache[41] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'change')),
          onInput: _cache[42] || (_cache[42] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'input')),
          onClear: _cache[43] || (_cache[43] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'clear')),
          onBlur: _cache[44] || (_cache[44] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'blur')),
          onFocus: _cache[45] || (_cache[45] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'focus')),
          modelValue: __props.widgetData[__props.widgetConfig.prop],
          "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => __props.widgetData[__props.widgetConfig.prop] = $event)
        }, __props.widgetConfig, {
          placeholder: __props.widgetConfig.placeholder ? _ctx.$t(`${__props.widgetConfig.placeholder}`) : ''
        }), _createSlots({
          suffix: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.suffix || ''), 1)]),
          _: 2
        }, [__props.widgetConfig.prepend ? {
          name: "prepend",
          fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.prepend), 1)]),
          key: "0"
        } : undefined, __props.widgetConfig.append ? {
          name: "append",
          fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.widgetConfig.append), 1)]),
          key: "1"
        } : undefined]), 1040, ["modelValue", "placeholder"])]),
        default: _withCtx(() => [__props.widgetData[__props.widgetConfig.prop] !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", null, _toDisplayString(__props.widgetData[__props.widgetConfig.prop]), 1), __props.widgetConfig.showCopyBtn ?? true ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "mk-op-btn-non-focus",
          onClick: _cache[47] || (_cache[47] = $event => _ctx.copyValue(__props.widgetData[__props.widgetConfig.prop], $event)),
          style: {
            "margin-left": "20px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
          _: 1
        })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }, 16, ["disabled", "placement", "trigger"])) : (_openBlock(), _createElementBlock("span", {
        key: 20,
        onClick: _cache[48] || (_cache[48] = $event => addEvent(__props.widgetConfig, __props.widgetData[__props.widgetConfig.prop], 'click')),
        innerHTML: initData()
      }, null, 8, _hoisted_6))]);
    };
  }
});